import { render } from "./HistoryView.vue?vue&type=template&id=4f24405f"
import script from "./HistoryView.vue?vue&type=script&lang=js"
export * from "./HistoryView.vue?vue&type=script&lang=js"

import "./HistoryView.vue?vue&type=style&index=0&id=4f24405f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__